import axios from "axios";

var baseURL = "https://www.dentaljack.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.dentaljack.de"
) {
  baseURL = "https://loc.dentaljack.de";
}

if (window.location.hostname == "/www.dentaljack.de") {
  baseURL = "https:///www.dentaljack.de";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    // Authorization: "sdZdfcaeqwsc9jsd189asddsa219275asmygvlwdsjasd9a", // Achte auf das Leerzeichen nach 'Bearer'
    "Content-Type": "application/json",
  },
});

export default http;
